<template>
  <div>
    <a-tabs v-model="tabPage" @change="callback" type="card" style="margin-bottom:20px;">
      <a-tab-pane tab="批量导入" key="1">
        <a-upload-dragger
          name="file"
          :multiple="true"
          :action="uploadUrl"
          :before-upload="handleBefore"
          :headers="headers"
          @change="handleChange"
        >
          <p class="ant-upload-drag-icon" style="margin-bottom:10px;">
            <a-icon type="inbox"/>
          </p>
          <p class="ant-upload-hint">拖拽或点击以导入批量发货文件</p>
          <p class="ant-upload-text">30天内可修改运单号 &nbsp;批量修改直接覆盖导入&nbsp; 可一次性导入多家快递</p>
          <p class="ant-upload-text"> 发货时，填写快递公司名称时，请使用标准名称。如：顺丰速运。不要使用简写SF</p>
          <p class="text-template"><span @click.stop="downloadFile">下载发货模板</span></p>
        </a-upload-dragger>
      </a-tab-pane>
      <a-tab-pane tab="单个导入" key="2">
        <a-form :form="form">
          <a-form-item label="订单编号" v-bind="formItemLayout">
            <a-input placeholder="请输入" style="max-width:500px;"
                     v-decorator="['orderNo', { rules: [{ required: true, message: '请输入订单编号' }] }]"
            />
          </a-form-item>
          <a-form-item label="订单来源" v-bind="formItemLayout">
            <a-radio-group :disabled="submitId!=null"
                           v-decorator="['orderSource',{ rules: [{ required: true, message: '请选择订单来源' }] }]">
              <a-radio :value="1">云仓</a-radio>
              <a-radio :value="2">平台</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item label="快递单号" v-bind="formItemLayout">
            <a-input placeholder="请输入" style="max-width:500px;"
                     v-decorator="['expressOrderNo', { rules: [{ required: true, message: '请输入快递单号' }] }]"
            />
          </a-form-item>
          <a-form-item label="快递公司" v-bind="formItemLayout" style="margin-bottom:0;" required>
            <a-select
              show-search
              placeholder="请选择物流公司"
              option-filter-prop="children"
              style="width: 200px"
              v-decorator="['companyName']"
              @popupScroll="popupScrollEvent"
              @search="fetchSearch"
              @focus="focusEvent"
            >
              <a-select-option v-for="(item,index) in logisticsCompany" :key="index" :value="item.companyName">
                {{ item.companyName }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item v-bind="formItemLayoutBtn" style="margin-top:15px;">
            <a-button type="primary" @click="handleSubmit" :loading="submitLoading">确认发货</a-button>
            <a-button @click="reset">重置</a-button>
          </a-form-item>
        </a-form>
      </a-tab-pane>
    </a-tabs>
    <a-modal
      title="批量导入失败单号"
      :visible="visible"
      @cancel="handleCancel"
      :footer="null"
      :maskClosable="false"
    >
      <ul>
        <li v-for="(item,index) in errorList" :key="index">订单号：{{ item }}</li>
      </ul>
    </a-modal>
  </div>
</template>

<script>
import formMixins from '../../../utils/mixins/formMixins'

export default {
  name: 'batchDelivery',
  mixins: [formMixins],
  data() {
    return {
      errorList: [],
      submitLoading: false,
      visible: false,
      submitId: null,
      tabPage: '1',
      headers: {
        token: this.$store.getters.token
      },
      uploadUrl: this.getAppConfig().orderUrl + 'api/v2/order/delivery/batch',
      logisticsNumber: 0,
      logisticsCompany: [],
      scrollPage: 1,
      curPage: 1,
      pageCount: 1
    }
  },
  mounted() {
  },
  methods: {
    getCourierServicesCompany(pageNum, value) {
      let params = {
        companyName: value ? value : '',
        limitDto: {
          pageNum: pageNum,
          pageSize: 20
        }
      }
      this.getHttpServices().getServerApiService().post('express/base/list', params)
        .then(res => {
          if (pageNum == 1) {
            this.logisticsCompany = res.data
          } else {
            this.logisticsCompany = this.logisticsCompany.concat(res.data)
          }
          this.curPage = res.curPage
          this.pageCount = res.pageCount
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    popupScrollEvent(e) {
      const { scrollHeight, scrollTop, clientHeight } = e.target
      if (scrollTop + clientHeight + 1 >= scrollHeight) {
        this.scrollPage++
        if (this.curPage < this.pageCount) {
          this.getCourierServicesCompany(this.scrollPage)
        }
      }
    },
    fetchSearch(value) {
      this.getCourierServicesCompany(this.scrollPage, value)
    },
    focusEvent() {
      this.scrollPage = 1
      this.logisticsCompany = []
      this.getCourierServicesCompany(this.scrollPage)
    },
    handleCancel() {
      this.visible = false
    },
    callback(key) {
      this.tabPage = key
      this.getLogUtils().logWithTag('key', this.tabPage)
    },
    handleSubmit() {
      this.validateFormParams().then(res => {
        this.getLogUtils().logWithTag('表单数据', res)
        let params = new Object()
        params.companyName = res.companyName
        params.expressOrderNo = res.expressOrderNo
        params.orderNo = res.orderNo
        params.id = this.submitId
        params.orderSource = res.orderSource
        this.getLogUtils().logWithTag('保存表单数据', params)
        if (!params.companyName) {
          this.$message.error('快递公司不能为空')
          return
        }
        this.submitLoading = true
        this.getHttpServices().getOrderService().post('api/v2/order/delivery/submit', params)
          .then(res => {
            this.getLogUtils().logWithTag('==handleSubmit==', res)
            if (res) {
              this.$message.warning(res)
            } else {
              this.$message.success('物流信息导入成功')
            }
            this.$emit('change')
          }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
      })
    },
    // 下载模板
    downloadFile() {
      window.open('https://imgb.woyoubooking.com/config/shippingTemplate.xlsx')
    },
    handleChange(info) {
      const status = info.file.status
      this.errorList = []
      if (status !== 'uploading') {
        this.getLogUtils().logWithTag(info.file, info.fileList)
      }
      if (status === 'done') {
        if (info.file.response.status == 1) {
          this.$message.success('文件上传成功')
          this.$emit('change')
          if (info.file.response.data) {
            this.visible = true
            let list = info.file.response.data
            this.errorList = list.split(',')
          }
        } else {
          this.$message.error(info.file.response.msg)
        }
      } else if (status === 'error') {
        this.$message.error(`${info.file.name} 文件上传失败`)
      }
    },
    getCompanyInfo(id) {
      this.submitId = id
      this.tabPage = '2'
      this.getHttpServices().getOrderService().get('api/v2/order/delivery/detail?id=' + id, '').then(res => {
        this.getLogUtils().logWithTag('==getCompanyInfo==', res)
        this.$nextTick(() => {
          this.form.setFieldsValue({
            orderNo: res.orderNo,
            expressOrderNo: res.expressOrderNo,
            companyName: res.companyName,
            orderSource: res.orderSource
          })
        })
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    handleBefore(file) {
      if (this.handleBeforeUploadExcelFile(file)) {
        return true
      }
      return false
    },
    reset() {
      this.submitId = null
      this.form.resetFields()
    }
  }
}
</script>
<style lang="less">
.text-template {
  font-size: 16px;
  color: #FAAD14;
  font-weight: 400;
  text-align: right;
  padding-right: 20px;
}

ul, li {
  list-style: none;
  margin: 0;
}

li {
  margin-bottom: 10px;
}
</style>